import { Banner } from '@dawn/ui';
import { AlertTriangle } from 'lucide-react';

import { useSessionStore } from '@/stores/session';

function getWarningMessage(status: string): string {
  if (status === 'max_age_warning') {
    return 'Your session will expire in approximately 10 minutes. You will need to log in again.';
  }
  return 'Your session is about to expire due to inactivity. Move your mouse or press a key to stay logged in.';
}

export function SessionWarningBanner() {
  const { status, bannerDismissed, dismissBanner } = useSessionStore();

  const isWarning = status === 'inactive_warning' || status === 'max_age_warning';

  if (!isWarning || bannerDismissed) return null;

  // Prioritize max_age_warning over inactive_warning
  const displayStatus = status === 'max_age_warning' ? 'max_age_warning' : status;

  return (
    <Banner
      variant="warning"
      dismissible
      onDismiss={dismissBanner}
      icon={<AlertTriangle className="h-4 w-4" />}
    >
      {getWarningMessage(displayStatus)}
    </Banner>
  );
}
